var _a;
import { TrilogyThemeContext } from '../../context/providerTheme';
import { useContext } from 'react';
/**
 * Trilogy color
 */
export var TrilogyColor;
(function (TrilogyColor) {
    TrilogyColor["BACKGROUND"] = "WHITE";
    TrilogyColor["MAIN"] = "MAIN";
    TrilogyColor["MAIN_FADE"] = "MAIN_FADE";
    TrilogyColor["ACCENT"] = "ACCENT";
    TrilogyColor["FONT"] = "FONT";
    TrilogyColor["FONT_PLACEHOLDER"] = "FONT_PLACEHOLDER";
    TrilogyColor["SUCCESS"] = "SUCCESS";
    TrilogyColor["SUCCESS_FADE"] = "SUCCESS_FADE";
    TrilogyColor["INFO"] = "INFO";
    TrilogyColor["INFO_FADE"] = "INFO_FADE";
    TrilogyColor["WARNING"] = "WARNING";
    TrilogyColor["WARNING_FADE"] = "WARNING_FADE";
    TrilogyColor["ERROR"] = "ERROR";
    TrilogyColor["ERROR_FADE"] = "ERROR_FADE";
    TrilogyColor["DISABLED"] = "DISABLED";
    TrilogyColor["DISABLED_FADE"] = "DISABLED_FADE";
    TrilogyColor["NEUTRAL"] = "NEUTRAL";
    TrilogyColor["NEUTRAL_FADE"] = "NEUTRAL_FADE";
    TrilogyColor["STROKE"] = "STROKE";
})(TrilogyColor || (TrilogyColor = {}));
/**
 * Trilogy color values
 */
export var colors = (_a = {},
    _a[TrilogyColor.BACKGROUND] = ['#fff', 'white', 'main'],
    _a[TrilogyColor.MAIN] = ['#3d5d7e', 'main', 'white'],
    _a[TrilogyColor.MAIN_FADE] = ['#BBC6CD', 'main-fade', 'white'],
    _a[TrilogyColor.ACCENT] = ['#da641b', 'accent', 'white'],
    _a[TrilogyColor.FONT] = ['#3d5d7e', 'main', 'white'],
    _a[TrilogyColor.FONT_PLACEHOLDER] = ['#687a87', 'font-placeholder', 'white'],
    _a[TrilogyColor.SUCCESS] = ['#007B52', 'success', 'white'],
    _a[TrilogyColor.SUCCESS_FADE] = ['#cae8ca', 'success-fade', 'white'],
    _a[TrilogyColor.INFO] = ['#1A688A', 'info', 'white'],
    _a[TrilogyColor.INFO_FADE] = ['#c8dbec', 'info-fade', 'white'],
    _a[TrilogyColor.WARNING] = ['#FFBB33', 'warning', 'white'],
    _a[TrilogyColor.WARNING_FADE] = ['#ecdbc6', 'warning-fade', 'white'],
    _a[TrilogyColor.ERROR] = ['#D42D02', 'error', 'white'],
    _a[TrilogyColor.ERROR_FADE] = ['#eecccc', 'error-fade', 'white'],
    _a[TrilogyColor.DISABLED] = ['#646464', 'disabled', 'white'],
    _a[TrilogyColor.DISABLED_FADE] = ['#D1D1D1', 'disabled-fade', 'white'],
    _a[TrilogyColor.NEUTRAL] = ['#707070', 'grey', 'white'],
    _a[TrilogyColor.NEUTRAL_FADE] = ['#F4F4F4', 'grey-fade', 'white'],
    _a[TrilogyColor.STROKE] = ['#BBC1CE', 'stroke', 'white'],
    _a);
/**
 * Returns color's className depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Color className value
 */
export var getColorClassName = function (trilogyColor) {
    var color = colors[trilogyColor];
    return color[1];
};
/**
 * Returns color button's className depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @returns {string} - Variant Button value
 */
export var getButtonVariantClassName = function (trilogyColor) {
    switch (trilogyColor) {
        case 'CONVERSION':
            return 'conversion';
        case 'PRIMARY':
            return 'primary';
        case 'SECONDARY':
            return 'secondary';
        case 'GHOST':
            return 'ghost';
        case 'SUCCESS':
            return 'success';
        case 'INFO':
            return 'info';
        case 'WARNING':
            return 'warning';
        case 'ERROR':
            return 'error';
        case 'DISABLED':
            return 'disabled';
        default:
            return 'primary';
    }
};
export var getButtonColorStyle = function (buttonVariant) {
    switch (buttonVariant) {
        case 'ACCENT':
            return TrilogyColor.ACCENT;
        case 'PRIMARY':
            return TrilogyColor.MAIN;
        case 'SECONDARY':
            return TrilogyColor.MAIN_FADE;
        case 'GHOST':
            return TrilogyColor.BACKGROUND;
        default:
            return TrilogyColor.MAIN;
    }
};
/**
 * Returns color's style depending on Trilogy Color
 * @param trilogyColor {string} - Trilogy Color
 * @param index {number} - Index of color ( 1 for BG )
 * @returns {string} - Color style value
 */
export var getColorStyle = function (trilogyColor) {
    if (typeof navigator !== 'undefined' && navigator.userAgent === undefined) {
        var theme = useContext(TrilogyThemeContext).theme;
        var colorsStyle = (theme === null || theme === void 0 ? void 0 : theme.colors) || colors;
        var colorArray = colorsStyle[trilogyColor] || colorsStyle.default;
        if (trilogyColor === 'transparent')
            return 'transparent';
        if (!trilogyColor || !colors[trilogyColor]) {
            return colorsStyle.default;
        }
        return colorArray[0];
    }
    else {
        if (trilogyColor === 'transparent')
            return 'transparent';
        return colors[trilogyColor][0] || colors[TrilogyColor.MAIN][0];
    }
};
function hexToRgb(hex) {
    if (hex.charAt(0) === '#') {
        hex = hex.slice(1);
    }
    if (hex.length !== 6) {
        throw new Error('Wrong format (hexadecimal)');
    }
    // Conversion
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return { r: r, g: g, b: b };
}
function rgbToHex(r, g, b) {
    var toHex = function (n) {
        var hex = n.toString(16);
        return hex.length === 1 ? "0".concat(hex) : hex;
    };
    return "#".concat(toHex(r)).concat(toHex(g)).concat(toHex(b));
}
export function grayscale(hex) {
    var _a = hexToRgb(hex), r = _a.r, g = _a.g, b = _a.b;
    // Formule de luminosité relative
    var gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);
    // Retourner la couleur en niveaux de gris
    return rgbToHex(gray, gray, gray);
}
//# sourceMappingURL=data:application/json;base64,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